import React from 'react';
import { PartnerLedgerBlocks } from '../components/integration/PartnerLedgerPages';

interface UserInfo {
  username: string;
  displayName: string;
  role: string;
  orgName: string;
  orgIcon: string;
  loginTime: string;
}

function EINSBlocks({ user }: { user: UserInfo }) {
  return <PartnerLedgerBlocks partner="EINS" user={user} />;
}

export default React.memo(EINSBlocks);
